import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '@isophi/core-ui';
import { DayOffsService, KindergartenDayOffWrite } from '@isophi/mng-api';
import { TranslocoService } from '@jsverse/transloco';
import { compareDesc } from 'date-fns';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, Subscription } from 'rxjs';

import { RouterLinkFactory } from '../../../../core/router/router-link.factory';
import { HelperService } from '../../../../core/services/helper.service';
import { HandleErrorService } from '../../../../shared/services/handle-error.service';
import { HolidaysDatesFormComponent } from '../../components/holidays-dates-form/holidays-dates-form.component';

@Component({
  selector: 'app-edit-holidays-dates',
  templateUrl: './edit-holidays-dates.component.html',
  styleUrls: ['./edit-holidays-dates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditHolidaysDatesComponent implements AfterViewInit, OnDestroy {
  @ViewChild(HolidaysDatesFormComponent) holidaysDatesFormComponent: HolidaysDatesFormComponent;

  private _dayOffId: string;

  private _subs: Subscription[] = [];

  constructor(
    public links: RouterLinkFactory,
    private helperService: HelperService,
    private translocoService: TranslocoService,
    private dayOffsService: DayOffsService,
    private spinner: NgxSpinnerService,
    private toastr: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private handleErrorService: HandleErrorService
  ) {
    this.helperService.setTitle(null, this.translocoService.translate('settings/editDaysOff'));
  }

  ngAfterViewInit(): void {
    this.route.paramMap.subscribe((params) => {
      const id = params.get('uuid');
      this._dayOffId = id;
      this._subs.push(
        this.dayOffsService.dayOffsRetrieve(id).subscribe((dayOff) => {
          this.holidaysDatesFormComponent.setFormData(dayOff);
        })
      );
    });
  }

  editDaysOff(holidaysDatesForm: KindergartenDayOffWrite): void {
    if (holidaysDatesForm.dateTo && compareDesc(holidaysDatesForm.date, holidaysDatesForm.dateTo) === -1) {
      this.toastr.error(this.translocoService.translate('evidence/dateError'));
    } else {
      this.spinner.show();

      this.dayOffsService
        .dayOffsUpdate(holidaysDatesForm, this._dayOffId)
        .pipe(finalize(() => this.spinner.hide()))
        .subscribe({
          next: () => {
            this.toastr.success(
              this.translocoService.translate('settings/addDaysOffSuccess'),
              this.translocoService.translate('settings/editDaysOff')
            );
            this.holidaysDatesFormComponent.resetGroupForm();
            this.router.navigate(this.links.holidaysDates());
          },
          error: (e) => {
            this.handleErrorService.handleFormError(e, 'settings/editDaysOff', 'settings/addDaysOffFailed');
          },
        });
    }
  }

  ngOnDestroy(): void {
    this._subs.forEach((sub) => sub.unsubscribe());
  }
}
